import {
  ADD_USER_APPLEPAY_EMAIL_FAIL,
  ADD_USER_APPLEPAY_EMAIL_REQUEST,
  ADD_USER_APPLEPAY_EMAIL_SUCCESS,
  ADD_USER_FAIL,
  ADD_USER_ID_FAIL,
  ADD_USER_ID_REQUEST,
  ADD_USER_ID_SUCCESS,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_USEDPROMO_FAIL,
  ADD_USER_USEDPROMO_REQUEST,
  ADD_USER_USEDPROMO_SUCCESS,
  DISCONNECT_USER_FAIL,
  DISCONNECT_USER_REQUEST,
  DISCONNECT_USER_SUCCESS,
  FIND_USER_FAIL,
  FIND_USER_REQUEST,
  FIND_USER_SUCCESS,
  MODIFY_USER_FAIL,
  MODIFY_USER_REQUEST,
  MODIFY_USER_SUCCESS,
  SAVE_USER_FAIL,
  SAVE_USER_REQUEST,
  SAVE_USER_SUCCESS,
  USER_CB_CARD_SUCCESS,
  USER_CB_PAYZEN_CARD_SUCCESS,
  USER_CLAIM_GIFT_FAIL,
  USER_CLAIM_GIFT_REQUEST,
  USER_CLAIM_GIFT_SUCCESS,
  USER_CONECS_PAYZEN_CARD_SUCCESS,
  USER_GET_GIFT_FAIL,
  USER_GET_GIFT_REQUEST,
  USER_GET_GIFT_SUCCESS,
  USER_INITIAL_PROMO_FAIL,
  USER_INITIAL_PROMO_REQUEST,
  USER_INITIAL_PROMO_SUCCESS,
  USER_PURCHASE_PROMO,
} from '../constants/userConstants';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';
import { notifyError, notifySuccess } from '../utils/Notify';
import {
  ACCOUNT,
  LOGIN,
  PROMO,
  ROOT,
  SCAN,
  SET_ACCOUNT,
  USER_FID_CARD_DETAIL,
} from '../constants/routes';
import Swal from 'sweetalert2';
import { isAppPWA } from '../utils/helper-functions';
import { addGuestId } from '../utils/GuestIdManagement/AddGuestId';
import { setSentryUser } from '../utils/GuestIdManagement/setSentryUser';
import { posthogUserIdentifyPikkoUserEvent } from '../posthog/userEvent';
import { logPhoneNumberLogin } from '../hooks/useAuthLogger';


export const addUser = (nom, prenom, email) => async (dispatch, getState) => {
  dispatch({ type: ADD_USER_REQUEST });
  try {
    dispatch({
               type: ADD_USER_SUCCESS,
               payload: { nom, prenom, email },
             });

    localStorage.setItem('user', JSON.stringify(getState().user));
  } catch (error) {
    console.error(error);
    dispatch({ type: ADD_USER_FAIL });
  }
};

export const addUserApplePayEmail =
  (user, axiosInstance) => async (dispatch, getState) => {
    console.info(user);

    dispatch(findUser(user.email, axiosInstance));

    dispatch({ type: ADD_USER_APPLEPAY_EMAIL_REQUEST });
    try {
      dispatch({
                 type: ADD_USER_APPLEPAY_EMAIL_SUCCESS,
                 payload: { email: user.apple_email },
               });

      localStorage.setItem('user', JSON.stringify(getState().user));
    } catch (error) {
      console.error(error);
      dispatch({ type: ADD_USER_APPLEPAY_EMAIL_FAIL });
    }
  };

// enregistrement cb
export const addUserId = (id) => async (dispatch, getState) => {
  dispatch({ type: ADD_USER_ID_REQUEST });
  try {
    dispatch({
               type: ADD_USER_ID_SUCCESS,
               payload: { id },
             });
    localStorage.setItem('user', JSON.stringify(getState().user));
  } catch (error) {
    console.error(error);
    dispatch({ type: ADD_USER_ID_FAIL });
  }
};

export const updatePayzenCards =
  (payzenCreditCards, paymentNetwork) => async (dispatch, getState) => {
    if (paymentNetwork === 'cb')
      dispatch({
                 type: USER_CB_PAYZEN_CARD_SUCCESS,
                 payload: payzenCreditCards,
               });
    else
      dispatch({
                 type: USER_CONECS_PAYZEN_CARD_SUCCESS,
                 payload: payzenCreditCards,
               });
    const updatedUser = getState().user;
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

export const addUsedPromo =
  (user, axiosInstance, cartItems, saveCard, creditCard) =>
    async (dispatch, getState) => {
      dispatch({ type: ADD_USER_USEDPROMO_REQUEST });
      const usedPromo =
        user.usedPromo && Object.keys(user.usedPromo).length === 0
          ? []
          : user.usedPromo || [];
      user.currentPromo =
        user.currentPromo && Object.keys(user.currentPromo).length === 0
          ? []
          : user.currentPromo || [];

      // Correction de l'expression ternaire avec JSX
      if (cartItems.promo && cartItems.promo.length > 0) {
        usedPromo.push(cartItems.promo);
      }

      // Capture l'état de isPayzenConecs avant la requête
      const isConecs = creditCard && creditCard.isPayzenConecs === true;
      const isPayzen = creditCard && creditCard.isPayzen === true;

      console.info('État avant requête:', { isConecs, isPayzen });

      axiosInstance
        .put('/user/addUsedPromo', {
          user: user,
          order: cartItems,
          creditCard,
          saveCard,
        })
        .then((response) => {
          dispatch({ type: ADD_USER_USEDPROMO_SUCCESS, payload: response.data });
          if (saveCard) {
            console.info('Objet creditCard après requête:', creditCard);

            // Utilise les variables capturées avant la requête
            if (isConecs) {
              console.info('Dispatching CONECS card');
              dispatch({
                         type: USER_CONECS_PAYZEN_CARD_SUCCESS,
                         payload: response.data.payzenConecsCreditCards,
                       });
            } else if (isPayzen) {
              console.info('Dispatching PAYZEN card');
              dispatch({
                         type: USER_CB_PAYZEN_CARD_SUCCESS,
                         payload: response.data.payzenCreditCards,
                       });
            } else {
              console.info('Dispatching regular card');
              dispatch({
                         type: USER_CB_CARD_SUCCESS,
                         payload: response.data.creditCard,
                       });
            }
          }
          localStorage.setItem('user', JSON.stringify(getState().user));
          localStorage.setItem('previousOrder', JSON.stringify(cartItems));
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: ADD_USER_USEDPROMO_FAIL });
        });
    };

export const saveUser =
  (user, axiosInstance, order, navigate, uuid) => async (dispatch, getState) => {
    const isPWA = isAppPWA();
    if (!auth.currentUser || !auth.currentUser.metadata) {
      console.log('User metadata are not loaded', auth.currentUser);
      return;
    }
    dispatch({ type: SAVE_USER_REQUEST });
    const lastLoginAt = auth.currentUser.metadata.lastLoginAt;
    user = addGuestId(user);
    axiosInstance
      .post('/user', { user, order, lastLoginAt, isPWA, uuid })
      .then((response) => {
        dispatch({ type: SAVE_USER_SUCCESS, payload: response.data });
        localStorage.setItem('user', JSON.stringify(getState().user));

        if (localStorage.getItem('PREV_LOGIN_PAGE') === 'invitation') {
          navigate(PROMO);
        } else if (localStorage.getItem('PREV_LOGIN_PAGE') === 'fidScan') {
          notifySuccess('Carte ajoutée !');
          navigate(SCAN);
        } else if (
          localStorage.getItem('fidCardNum') &&
          response?.fidCard[0]?.length > 0
        ) {
          navigate(USER_FID_CARD_DETAIL);
        } else if (
          !localStorage.getItem('order') ||
          !localStorage.getItem('store')
        ) {
          navigate(ROOT);
        } else {
          navigate(ACCOUNT);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          dispatch(logout(navigate));
        } else {
          console.error('Save user fail', error);
          dispatch({ type: SAVE_USER_FAIL });
        }
      });
  };
export const savePhoneNumberUser =
  (user, axiosInstance, order, navigate, action, setlockUntil, setError,setLoading) =>
    async (dispatch, getState) => {
      if(setLoading) {
        setLoading(true);
      }
      const webService =
        action === 'signup' ? 'user/phoneNumberSignUp' : 'user/phoneNumberSignIn';
      if (action === 'signup') {
        if (!auth.currentUser || !auth.currentUser.metadata) {
          console.log('User metadata are not loaded', auth.currentUser);
          return;
        }
      }
      const guestId = localStorage.getItem('guestId');
      if (guestId) {
        user.guestId = guestId;
      }
      const firebaseUid = auth?.currentUser?.uid;
      if (firebaseUid) {
        user.firebaseUid = firebaseUid;
      }
      const isPWA = isAppPWA();
      dispatch({ type: SAVE_USER_REQUEST });
      const lastLoginAt = auth?.currentUser?.metadata?.lastLoginAt;
      setError(null);
      axiosInstance
        .post(webService, { user, order, lastLoginAt, isPWA })
        .then((response) => {
          logPhoneNumberLogin(axiosInstance, order?._id, response.data, true);
          dispatch({ type: SAVE_USER_SUCCESS, payload: response.data });

          localStorage.setItem('user', JSON.stringify(getState().user));

          if (localStorage.getItem('PREV_LOGIN_PAGE') === 'invitation') {
            navigate(PROMO);
          } else if (localStorage.getItem('PREV_LOGIN_PAGE') === 'config') {
            if (!response.data.favoriteStore && isPWA) {
              navigate(SET_ACCOUNT);
            } else {
              //navigate vers config Cartes
            }
          } else if (localStorage.getItem('PREV_LOGIN_PAGE') === 'fidScan') {
            notifySuccess('Carte ajoutée !');
            navigate(SCAN);
          } else if (
            localStorage.getItem('fidCardNum') &&
            response &&
            response.fidCard &&
            response.fidCard.length > 0
          ) {
            navigate(USER_FID_CARD_DETAIL);
          } else if (localStorage.getItem('PREV_LOGIN_PAGE') === SCAN) {
            navigate(SCAN);
            return;
          } else if (localStorage.getItem('isNewPWA')) {
            localStorage.removeItem('isNewPWA');
            navigate('/');
            return;
          } else {
            navigate(ACCOUNT);
          }
        })
        .catch((error) => {
          if(setLoading) {
            setLoading(false);
          }
          const errorData = {
            code : error.code,
            error: error.message,
            status: error.response?.status,
            name: error.name,
            message: error.response?.data?.message,
            statusText: error.response?.statusText,
          }
          logPhoneNumberLogin(axiosInstance, order?._id, errorData, false);
          dispatch({ type: SAVE_USER_FAIL });
          if (error?.response?.status === 401) {
            dispatch(logout(navigate));
          } else if (error?.response?.status === 406) {
            if (error?.response?.data?.lockUntil) {
              localStorage.setItem('lockUntil', error?.response?.data?.lockUntil);
              setlockUntil(error?.response?.data?.lockUntil);
            } else {
              localStorage.removeItem('lockUntil');
              setlockUntil(null);
            }
            setError(error?.response?.data?.message);
            notifyError('Oups', error?.response?.data?.message);
          } else if (error?.response?.status === 429) {
            const retryAfter = error?.response?.data?.error?.retryAfter;
            if (retryAfter) {
              const lockDate = new Date(Date.now() + retryAfter * 1000).toISOString();
              localStorage.setItem('lockUntil', lockDate);
              setlockUntil(lockDate);
            }
            setError('Trop de tentatives, patiente un instant');
            notifyError('Oups', 'Trop de tentatives, patiente un instant');
          } else if (error?.response?.status === 409) {
            notifyError(
              'Oups',
              'Ce numéro de téléphone est déjà utilisé par un autre compte',
            );
          } else {
            console.error('Save user fail', error);
          }
        });
    };

export const mergeAccounts = async (
  axiosInstance,
  firstAccountID,
  secondAccount,
  type,
  dispatch,
  user,
  navigate,
) => {
  try {
    const data = await axiosInstance.post('/user/synchronisation', {
      firstAccountID: firstAccountID,
      secondAccount: secondAccount,
      type: type,
    });
    if (data.status === 200) {
      Swal.fire({
                  title: data.data.title,
                  text: data.data.message,
                  showLoaderOnConfirm: true,
                  icon: 'success',
                  confirmButtonColor: '#FFD700',
                  confirmButtonText: '<button className="payer w-full p-6 ">Ok</button>',
                  buttonsStyling: false,
                  preConfirm: async () => {
                    localStorage.removeItem('fusionFirstAccount');
                    try {
                      const newUser = await dispatch(
                        findUser(user, axiosInstance, navigate),
                      );
                      if (newUser) {
                        return newUser;
                      }
                    } catch (e) {
                      console.log(e);
                      return null;
                    }
                  },
                  allowOutsideClick: () => !Swal.isLoading(),
                }).then((result) => {
        if (result.isConfirmed) {
          Swal.close();
        }
      });

      return data.data;
    } else {
      notifyError(data.data.message);
      localStorage.removeItem('fusionFirstAccount');
    }
  } catch (error) {
    console.log(error);
    notifyError(error.response?.data?.message);
  }
};

export const saveUserWithFid =
  (profile, axiosInstance, order, fidCardNum, navigate) =>
    async (dispatch, getState) => {
      if (!auth.currentUser || !auth.currentUser.metadata) {
        console.log('User metadata are not loaded', auth.currentUser);
        return;
      }
      dispatch({ type: SAVE_USER_REQUEST });

      const lastLoginAt = auth.currentUser.metadata.lastLoginAt;

      axiosInstance
        .post('/user/fid', { user: profile, order, lastLoginAt, fidCardNum })
        .then((response) => {
          dispatch({ type: SAVE_USER_SUCCESS, payload: response.data });
          localStorage.setItem('user', JSON.stringify(getState().user));

          if (localStorage.getItem('PREV_LOGIN_PAGE') === 'invitation') {
            navigate(PROMO);
          } else {
            const fidCard = response.data.fidCard.find(
              (card) => fidCardNum === card.fidelityCardPhysicalId,
            );
            navigate(USER_FID_CARD_DETAIL, {
              state: { fidCard, fromLogin: true },
            });
          }
        })
        .catch((error) => {
          dispatch({ type: SAVE_USER_FAIL });
          if (error.response?.status === 401) {
            dispatch(logout(navigate));
          } else {
            console.error('Save user fail', error);
          }
          if (error.response?.data?.errorCode === 'USER_FID_CARD_ALREADY_USED') {
            notifyError(
              'Oups',
              'L\'email ne correspond à la carte de fidélité',
              navigate('/account'),
            );
          } else {
            notifyError(
              'Oups',
              'Une erreur est survenue lors de ta connexion.',
              navigate('/account'),
            );
          }
        });
    };

export const findUser =
  (user, axiosInstance, navigate) => async (dispatch, getState) => {

    dispatch({ type: FIND_USER_REQUEST });
    user = addGuestId(user);

    axiosInstance
      .put('/user', { userId: user._id })
      .then((response) => {
        dispatch({ type: FIND_USER_SUCCESS, payload: response.data });
        localStorage.setItem('user', JSON.stringify(getState().user));
        if (user?._id) {
          posthogUserIdentifyPikkoUserEvent(user)
        }
      })
      .catch((error) => {
        if (
          error.response?.status === 401 ||
          error.response?.status === 403 ||
          error.response?.status === 404
        ) {
          dispatch(logout(navigate));
        } else {
          console.error('Find user', error);
          localStorage.setItem('user', JSON.stringify(getState().user));
          if (user?._id) {
            posthogUserIdentifyPikkoUserEvent(user)
          }
        }
        dispatch({ type: FIND_USER_FAIL });
      });
  };

export const logout = (navigate) => async (dispatch) => {
  dispatch(disconnectUser());
  signOut(auth).then(() => {
    if (navigate) {
      navigate(LOGIN);
    }
    localStorage.removeItem('popupUser');
  });
};

export const disconnectUser = () => async (dispatch) => {
  dispatch({ type: DISCONNECT_USER_REQUEST });
  try {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const filteredPromoWelcomeUserInfo =
      user.currentPromo?.filter((item) => item.type.includes('welcome')) || [];

    console.info(filteredPromoWelcomeUserInfo);

    const newUserObject = {
      usedPromo: user.usedPromo || [],
      currentPromo: filteredPromoWelcomeUserInfo,
      appliedPromo: user.appliedPromo || [],
    };

    console.info(newUserObject);
    const newUserJSON = JSON.stringify(newUserObject);
    localStorage.setItem('user', newUserJSON);

    dispatch({ type: DISCONNECT_USER_SUCCESS, payload: newUserObject });
  } catch (error) {
    console.error('DISCONNECT_USER_FAIL', error);
    dispatch({ type: DISCONNECT_USER_FAIL });
  }
};

export const userInitialPromo =
  (user, axiosInstance) => async (dispatch, getState) => {
    dispatch({ type: USER_INITIAL_PROMO_REQUEST });
    try {
      const { data } = await axiosInstance.put('/promos/initialPromo', {
        user: user,
      });
      const userData = JSON.parse(localStorage.getItem('user'));
      const guestId = localStorage.getItem('guestId');
      setSentryUser(userData, guestId);
      dispatch({ type: USER_INITIAL_PROMO_SUCCESS, payload: data });
      localStorage.setItem('user', JSON.stringify(getState().user));
    } catch (error) {
      console.log(error);
      dispatch({ type: USER_INITIAL_PROMO_FAIL });
      localStorage.setItem('user', JSON.stringify(getState().user));
    }
  };

export const purchasePromo = (payload) => async (dispatch, getState) => {
  dispatch({ type: USER_PURCHASE_PROMO, payload });
  localStorage.setItem('user', JSON.stringify(getState().user));
};

export const claimUserGift =
  (userId, axiosInstance, promoItem) => async (dispatch, getState) => {
    dispatch({ type: USER_CLAIM_GIFT_REQUEST });
    try {
      const { data } = await axiosInstance.put(`/user/claimgift/${userId}`, {
        gift: promoItem,
      });
      console.log(data);
      dispatch({ type: USER_CLAIM_GIFT_SUCCESS, payload: data });
      localStorage.setItem('user', JSON.stringify(getState().user));
    } catch (error) {
      console.error(error);
      alert('Une erreur s\'est produite');
      dispatch({ type: USER_CLAIM_GIFT_FAIL });
      localStorage.setItem('user', JSON.stringify(getState().user));
      window.location.reload();
    }
  };

export const modifyUserStore =
  (user, axiosInstance, storeId) => async (dispatch, getState) => {
    dispatch({ type: MODIFY_USER_REQUEST });
    try {
      const { data } = await axiosInstance.put('/user/addStore', {
        user: user,
        storeId: storeId,
      });
      dispatch({ type: MODIFY_USER_SUCCESS, payload: data.user });
      localStorage.setItem('user', JSON.stringify(getState().user));
      console.info(data);
    } catch (e) {
      dispatch({ type: MODIFY_USER_FAIL });
      localStorage.setItem('user', JSON.stringify(getState().user));
      console.error(e);
    }
  };

export const updateUserProfile =
  (userId, axiosInstance) => async (dispatch, getState) => {
    dispatch({ type: MODIFY_USER_REQUEST });
    try {
      const { data } = await axiosInstance.get('/user/profile', {
        params: { userId },
      });
      dispatch({ type: MODIFY_USER_SUCCESS, payload: data.user });
      localStorage.setItem('user', JSON.stringify(getState().user));
    } catch (e) {
      dispatch({ type: MODIFY_USER_FAIL });
      localStorage.setItem('user', JSON.stringify(getState().user));
      console.info(e);
    }
  };

export const updateUserWithFidelityCard = (fidelityCardData) => async (dispatch, getState) => {
  dispatch({ type: MODIFY_USER_REQUEST });
  try {
    const currentUser = getState().user;
    const updatedUser = {
      ...currentUser,
      fidCard: [fidelityCardData]
    };

    dispatch({ type: MODIFY_USER_SUCCESS, payload: updatedUser });
    console.log('updatedUser before localStorage', updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));

    console.info('User updated with fidelity card:', updatedUser);
  } catch (error) {
    console.error('Error updating user with fidelity card', error);
    dispatch({ type: MODIFY_USER_FAIL });
  }
};


export const saveFidelityForm = (userId, fidelityForm, store, companyId, axiosInstance) => async (dispatch, getState) => {
  dispatch({ type: MODIFY_USER_REQUEST });
  try {
    const { data } = await axiosInstance.put('/user/fidelity-form-data', {
      userId,
      fidelityForm,
      store,
      companyId,
    });
    dispatch({ type: MODIFY_USER_SUCCESS, payload: data.user });
    localStorage.setItem('user', JSON.stringify(getState().user));
  } catch (error) {
    console.error('Error saving fidelity form', error);
    dispatch({ type: MODIFY_USER_FAIL });
  }
};

// ========== USER UPDATE & DELETION ==========

export const handleUserUpdate = (formDataPlat, axiosInstance, navigate, previousRoute) => async (dispatch, getState) => {
  const user = getState().user;

  if (!user?._id) {
    dispatch({ type: MODIFY_USER_FAIL });
    notifyError('Session expirée, reconnecte-toi.');
    if (navigate) {
      navigate(LOGIN);
    }
    return { success: false };
  }

  dispatch({ type: MODIFY_USER_REQUEST });

  try {
    const response = await axiosInstance.post(
      `/user/updateUser/${user._id}`,
      formDataPlat,
    );

    if (response.status === 200) {
      dispatch({ type: MODIFY_USER_SUCCESS, payload: response.data.user });
      localStorage.setItem('user', JSON.stringify(getState().user));
      notifySuccess('Ton compte a été mis à jour avec succès !');
      if (navigate) {
        navigate(previousRoute || ACCOUNT);
      }
      return { success: true };
    } else {
      dispatch({ type: MODIFY_USER_FAIL });
      notifyError(
        'Une erreur est survenue lors de la mise à jour de ton compte réessaye plus tard😕',
      );
      return { success: false };
    }
  } catch (error) {
    dispatch({ type: MODIFY_USER_FAIL });
    if (error?.response?.data?.message) {
      notifyError(error?.response?.data?.message);
    }
    return { success: false };
  }
};

export const handleAccountDeletion = (reason_id, reason_label, details, axiosInstance, navigate) => async (dispatch, getState) => {
  const user = getState().user;

  if (!user?._id) {
    dispatch({ type: MODIFY_USER_FAIL });
    notifyError('Session expirée, reconnecte-toi.');
    if (navigate) {
      navigate(LOGIN);
    }
    return { success: false };
  }

  dispatch({ type: MODIFY_USER_REQUEST });

  try {
    const response = await axiosInstance.post(
      `/user/deleteUser/${user._id}`,
      {
        reason_id,
        reason_label,
        details,
      },
    );

    if (response.status === 200) {
      localStorage.removeItem('user');
      dispatch({ type: DISCONNECT_USER_SUCCESS, payload: {} });
      notifySuccess(
        'Ton compte a bien été supprimé! nous espérons te revoir bientôt 😁',
      );
      if (navigate) {
        await dispatch(logout(navigate, response.status));
      }
      return { success: true };
    } else {
      dispatch({ type: MODIFY_USER_FAIL });
      return { success: false };
    }
  } catch (error) {
    console.error('Error in deleteAccount', error);
    dispatch({ type: MODIFY_USER_FAIL });
    notifyError(
      'Une erreur est survenue lors de la suppression de ton compte réessaye plus tard',
    );
    return { success: false };
  }
};
